import { Box, Heading } from "@vinomofo/components";

import { CircleMinusIcon } from "@vinomofo/icons";
import * as React from "react";
import styled from "styled-components";
import { tint } from "polished";
import { ALL_FACETS } from "../instant-search/refinements";

type CurrentFilterItemProps = {
  label: string;
  count?: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const StyledHeading = styled(Heading)`
  margin: 4px 0;
  font-size: 14px;
  font-family: "GT Walsheim", sans-serif;
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1;
`;

const CurrentFilterItem = ({
  label,
  count,
  onClick,
}: CurrentFilterItemProps): JSX.Element => {
  const customLabel = ALL_FACETS.find((el) => el.label === label);
  return (
    <Wrapper mr={["4px", "6px"]}>
      <NavButton
        display="flex"
        border="2px solid"
        borderColor="#e2e2e2"
        backgroungColor="#f7f8fa"
        padding={["2px 6px", "3px 9px"]}
        borderRadius={100}
        textAlign="center"
        minWidth="auto"
        height="100%"
        alignItems="center"
        justifyContent="space-between"
      >
        <StyledHeading fontSize={["12px", "14px"]} as="h3" fontWeight="600">
          {customLabel?.pillsLabel ?? label}
        </StyledHeading>
        <Box display="flex" justifyContent="space-between" textAlign="center">
          {count && !customLabel && (
            <Heading
              fontSize={["12px", "14px"]}
              as="p"
              lineHeight="1.6em"
              fontWeight="600"
            >
              ({count})
            </Heading>
          )}
          <span onClick={onClick} title="Remove from filter">
            <CircleMinusIcon size="16px" />
          </span>
        </Box>
      </NavButton>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  text-decoration: none;
  white-space: nowrap;
  // cursor: default;

  &:last-child {
    margin-right: 0;
  }

  &:first-of-type {
    margin-left: 0;
  }
`;

const NavButton = styled(Box)<{
  borderColor: string;
  active: boolean;
  backgroungColor: string;
}>`
  background-color: ${({ backgroungColor }) => backgroungColor};
  border-color: ${({ borderColor }) => tint(0.6, borderColor)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.white};

    h3,
    p,
    svg {
      color: ${({ theme }) => theme.colors.mofoGreen};
    }
  }

  h3,
  p {
    user-select: none;
    padding-left: 10px;
    color: ${({ theme }) => theme.colors.darkMofo};
  }

  h3 {
    padding-left: 0;
  }

  svg {
    margin-left: 10px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.dorianGray};
    opacity: 0.8;

    &:hover {
      opacity: 1;
      color: ${({ theme }) => theme.colors.mofoGreen};
    }
  }

  span {
    line-height: 1.5em;
    align-items: center;
    display: flex;
  }
`;

export default CurrentFilterItem;
